function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.414 17l5.293 5.293a1 1 0 1 1-1.414 1.414l-6.647-6.646a1.5 1.5 0 0 1 0-2.122l6.647-6.646a1 1 0 1 1 1.414 1.414L5.414 15H29a1 1 0 1 1 0 2H5.414z"
});

var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "0f730a1d5fa25384f6dc61e93157b978.svg";
export { SvgArrowLeft as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/arrow-left.svg
// module id = null
// module chunks = 